<template>
    <div class="left-panel-well-details">
        <div class="well-credentials">
            <template v-if="isGeriOrMiri"> <well-chamber-number />&nbsp;|&nbsp; </template>
            <well-id :well="focusedWell" />
            <well-embryo-id-view class="responsive" :with-bar="isGeriOrMiri" :well="focusedWell" />
        </div>

        <div v-if="!isFdaFriendly" class="well-event">
            <i class="fa fa-arrow-right" />
            <well-last-event :well="focusedWell" mode="simple" />
        </div>

        <well-status-controls :well="focusedWell" class="focused my-2" />

        <pn-duc-deg-fix-panel v-if="!isFdaFriendly" :well="focusedWell" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { INSTRUMENT_TYPE } from '../../business/const'
import WellId from './WellId'
import WellStatusControls from './common/WellStatusControls'
import WellEmbryoIdView from './common/WellEmbryoIdView'
import WellLastEvent from './common/WellLastEvent'
import PnDucDegFixPanel from './partials/PnDucDegFixPanel'
import WellChamberNumber from './WellChamberNumber'

export default {
    name: 'LeftPanelWellDetails',
    components: {
        WellChamberNumber,
        WellStatusControls,
        WellId,
        WellEmbryoIdView,
        WellLastEvent,
        PnDucDegFixPanel
    },
    props: {
        focusedWell: {
            type: Object,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            isFdaFriendly: 'common/isFdaFriendly',
            getSelectedInstrument: 'timelapse/getSelectedInstrument'
        }),
        isGeriOrMiri() {
            return (
                this.getSelectedInstrument.type &&
                [INSTRUMENT_TYPE.GERI, INSTRUMENT_TYPE.MIRI].includes(
                    this.getSelectedInstrument.type
                )
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.left-panel-well-details {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;

    .well-credentials,
    .well-event {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
    }

    .fa-arrow-right {
        // makes icon thinner
        -webkit-text-stroke: 0.1rem $dark-2;
        margin: 0 0.5rem;
    }

    .well-last-event {
        margin-right: 0.5rem;
    }

    @media screen and #{$new-break3close} {
        .well-status-controls {
            margin-left: auto;
        }
        .pn-duc-deg-fix-panel {
            margin-left: auto;
        }
    }

    @media screen and #{$new-break4} {
        flex-direction: column;
        align-items: stretch;

        .well-id,
        .well-embryo-id-view,
        .well-last-event {
            font-size: 16px !important;
        }
    }

    @media screen and #{$new-break4open} {
        justify-content: space-between;
        border-bottom: $border-narrow-dark-4;

        .well-embryo-id-view {
            margin: 0 0.5rem;
        }
        .pn-duc-deg-fix-panel {
            display: none;
        }
    }
    @media screen and #{$new-break5open} {
        margin-bottom: 1rem;

        .well-status-controls {
            margin-left: auto;
        }
    }
}
</style>
